import { RootState } from "@/store";
import { Subscription, Controllers } from "@infoland/iprova-api";
import { ActionTree } from "vuex";

// state type
export interface SubscriptionState {
    subscriptions: Subscription[];
}

export function initialize(): SubscriptionState {
    return {
        subscriptions: null
    };
}

// initial state
const state: SubscriptionState = initialize();

// getters for this store
const getters = {
    /**
     * The recent subscription items
     * @param state The state to read from
     */
    subscriptions(state: SubscriptionState): Subscription[] {
        return state.subscriptions;
    }
};

// mutations for this store
const mutations = {
    /**
     * Set the recent content items
     * @param state The state to write to
     * @param subscriptions the returned content items from recent ones
     */
    _subscriptions(state: SubscriptionState, subscriptions: Subscription[]): void {
        // undefined should become null
        if (!subscriptions) {
            subscriptions = null;
        }

        state.subscriptions = subscriptions;
    },

    _updateSubscription(state: SubscriptionState, subscriptionUpdates: SubscriptionUpdates): void {
        const subscription = state.subscriptions.find(x => x.subscription_id == subscriptionUpdates.id);
        subscription.mail_frequency = subscriptionUpdates.mail_frequency ?? subscription.mail_frequency;
        subscription.show_in_messages_list = subscriptionUpdates.show_in_messages_list ?? subscription.show_in_messages_list;
    }
};

// actions for this store
const actions: ActionTree<SubscriptionState, RootState> = {
    async loadMySubscriptionsAsync({ state, commit }): Promise<Subscription[]> {
        // tslint:disable-next-line: max-line-length
        const getResponse: Subscription[] = await Controllers.UserSubscriptionsController.getMyUserSubscriptionsAsync();
        commit("_subscriptions", getResponse);
        return getResponse;
    },

    async saveSubscriptionAsync({ commit }, { subscription_Id, subscriptionPatch }): Promise<boolean> {
        let result = await Controllers.UserSubscriptionsController.patchSubscriptionAsync(subscription_Id, subscriptionPatch);
        commit("_updateSubscription", {
            id: subscription_Id,
            mail_frequency: subscriptionPatch.mail_frequency,
            show_in_messages_list: subscriptionPatch.show_in_messages_list
        });
        return result;
    }
};

interface SubscriptionUpdates {
    id: number;
    mail_frequency?: number;
    show_in_messages_list?: boolean;
}

// export the namespace
export const namespace = "subscriptions";

// export the store 'module'
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
